import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import * as Actions from './store/actions/index'
import * as AssetActions from '../../content/asset/store/actions';
import * as PanelActions from 'main/quickPanel/store/actions/index'
import RichTextEditor from 'react-rte';
import UserNoteDialog from './UserNoteDialog';
import UserNoteAssetDialog from './UserNoteAssetDialog';

import { Tooltip } from '@material-ui/core';

import {
    Typography,
    IconButton,
    Divider,
    Tabs,
    Tab,
    MenuItem,
    Checkbox,
    ListItemText,
    Menu,
    Icon
} from '@material-ui/core/';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ClearIcon from '@material-ui/icons/Clear';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import * as jsPDF from 'jspdf'
import * as htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

import * as html2pdf from 'html2pdf.js';

const drawerWidth = 480;

const styles = theme => ({
    editor: {
        "min-height": "150px",
        height: "800px",
    },
    DraftEditor: {
        '&root': {
            backgroundColor: 'purple'
        }
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing.unit / 4,
    },
    noLabel: {
        marginTop: theme.spacing.unit * 3,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',
        padding: '1em'
    },
    drawerContent: {
        padding: '1em'
    },
});

class UserNote extends Component {
    state = {
        edit_tab_id: 0,
        is_dialog_open: false,
        tabMenuAnchor: null,
        dialog_title: '',
        downloadMenuOpen: false,
        asset_dialog_open: false
    }

    componentDidMount = () => {
        const { getUserNoteList, auth } = this.props;

        getUserNoteList(auth.user.data.auth_id);
    }

    saveEditorState = (rte_value) => {
        this.props.updateCurrentNoteText(rte_value);
    }

    saveEditorToDatabase = debounce((note_text) => {
        const {
            current_user_note_detail_id,
            userNoteList,
            saveUserNoteDetail,
            current_tab,
        } = this.props;
        saveUserNoteDetail(
            current_user_note_detail_id,
            userNoteList[current_tab].user_note_id,
            note_text,
            userNoteList[current_tab].ChapterName,
        );
    }, 500)

    onEditorStateChange = (rte_value) => {
        this.saveEditorState(rte_value);
        this.saveEditorToDatabase(rte_value.toString('html'));
    }

    changeTab = (event, new_current_tab) => {
        const { setCurrentTab } = this.props;

        setCurrentTab(new_current_tab);
    }

    handleEditTab = (event, user_note_detail_id) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        this.setState({
            edit_tab_id: user_note_detail_id,
            dialog_title: "Edit Tab Name",
            is_dialog_open: true,
        });

        this.props.editTabName(this.props.userNoteList.filter((detail) => detail.user_note_detail_id === user_note_detail_id)[0].ChapterName);
    }

    handleRemoveTab = (event, user_note_detail_id) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        this.props.setActiveTab(user_note_detail_id, false);
    }

    handleTabCheckboxSelect = (user_note_detail_id, current_active_value) => {
        // Reverse value of Active
        this.props.setActiveTab(user_note_detail_id, !current_active_value);
    }

    handleClick = (event) => {
        this.setState({
            tabMenuAnchor: event.currentTarget
        });
    }

    handleClose = (event) => {
        this.setState({
            tabMenuAnchor: null
        });
    }

    handleNoteDialogOpen = () => {
        this.setState({
            is_dialog_open: true,
            edit_tab_id: 0,
            dialog_title: "Add New Tab"
        });

        this.props.editTabName("");
    }

    handleNoteAssetDialogOpen = () => {
        this.setState({
            asset_dialog_open: true,
        });

        this.props.editTabName("");
    }

    handleNoteDialogClose = () => {
        this.setState({
            is_dialog_open: false,
            edit_tab_id: 0,
            dialog_title: "",
        });
    }

    handleNoteAssetDialogClose = () => {
        this.setState({
            asset_dialog_open: false
        })
    }

    handleNoteDialogSubmit = (new_tab_name) => {
        const auth_id = this.props.auth.user.data.auth_id;
        const { edit_tab_id } = this.state;
        const {
            saveUserNoteDetail,
            current_user_note_id,
            userNoteList,
            edit_tab_name,
        } = this.props;


        if (edit_tab_id === 0) {
            this.props.addTab(auth_id, current_user_note_id, new_tab_name);
        } else {
            // Save new tab name to db
            const active_user_note_detail = userNoteList.filter((detail) => detail.user_note_detail_id === edit_tab_id)[0];

            saveUserNoteDetail(
                edit_tab_id,
                active_user_note_detail.user_note_id,
                active_user_note_detail.NoteText,
                edit_tab_name,
            );

            this.props.updateTabName(edit_tab_name, edit_tab_id);
        }

        this.setState({
            is_dialog_open: false,
            edit_tab_id: 0,
        });
    }

    deleteUserNoteDetail = (event, user_note_detail_id) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        const auth_id = this.props.auth.user.data.auth_id;
        this.props.deleteUserNoteDetail(auth_id, user_note_detail_id);
    }

    generatePDF() {
        let y = ''
        const pdf = new jsPDF('p', 'pt', 'letter')
        const margins = { top: 10, bottom: 10, left: 30, width: 550 }
        this.props.userNoteList.map((note, i) => {
            y = y.concat(`<div style="text-align: center"><b>${note.ChapterName}</b> </div>`)
            y = y.concat(`<div style="text-align: center"><span>${moment(note.LastEditDate).format('MM-DD-YYYY')}</span></div>`)
            y = y.concat(note.NoteText)
            if (i + 1 < this.props.userNoteList.length) {
                y = y.concat(`<!--ADD_PAGE-->`)
            }
        })
        pdf.fromHTML(y, margins.left, margins.top, { 'width': margins.width }, function (cb) { pdf.save('UniversityNotes') }, margins)
    }

    generateDOCX = () => {
        this.props.userNoteList.map(note => {
            const converted = htmlDocx.asBlob(note.NoteText);
            saveAs(converted, note.ChapterName)
        })
        // const curNote = this.props.userNoteList.filter(n => n.user_note_detail_id === this.props.current_user_note_detail_id)[0]
        // const converted = htmlDocx.asBlob(curNote.NoteText)
        // saveAs(converted, 'test.docx')
    }

    handleOpenDownloadMenu = (e) => {
        this.setState({ downloadMenuOpen: true, anchorEl: e.currentTarget })
    }

    handleDownloadMenuClose = (e) => {
        this.setState({ downloadMenuOpen: false, anchorEl: null })
    }

    render() {
        const { classes, userNoteList, current_note_text, toggleQuickPanel, current_tab } = this.props;
        const { tabMenuAnchor, is_dialog_open, dialog_title, edit_tab_id, anchorEl, downloadMenuOpen, asset_dialog_open } = this.state;
        const tab_menu_open = Boolean(tabMenuAnchor);
        const active_list_length = (userNoteList.filter((detail) => detail.Active)).length;

        // Hacky way to make the whole RTE clickable 
        const x = document.getElementsByClassName('DraftEditor-root')

        if (x.length > 0) {
            if (x.length === 2) {
                // if your already on a page that has an RTE, the user note will be the second one, so only change that height.
                x[1].style.height = '740px';
            }
            else {
                x[0].style.height = '740px'
            }
            
        }

        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            // display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
                { label: 'Italic', style: 'ITALIC' },
                { label: 'Underline', style: 'UNDERLINE' }
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: 'Normal', style: 'unstyled' },
                { label: 'Heading Large', style: 'header-one' },
                { label: 'Heading Medium', style: 'header-two' },
                { label: 'Heading Small', style: 'header-three' }
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: 'UL', style: 'unordered-list-item' },
                { label: 'OL', style: 'ordered-list-item' },
            ],
        };

        return (
            <React.Fragment>
                <div className={classes.drawerHeader}>
                    <Typography style={{ flex: 1 }}>Notes</Typography>

                    <Tooltip
                        title={`View/Upload assets for this tab`}
                        enterDelay={100}
                        // disabletriggerfocus={true}
                        disabletriggerfocus={'true'}
                    >
                        <IconButton
                            onClick={this.handleNoteAssetDialogOpen}
                        >
                            <Icon>backup</Icon>
                        </IconButton>
                    </Tooltip>

                    <Tooltip
                        // disableTriggerFocus={true}
                        disabletriggerfocus={'true'}
                        title={'Download all notes to PDF'}
                        enterDelay={100}
                    >
                        <IconButton
                            onClick={() => this.generatePDF()}
                        >
                            <Icon>archive</Icon>
                        </IconButton>
                    </Tooltip>


                    <IconButton
                        aria-label="Edit"
                        onClick={this.handleNoteDialogOpen}
                    >
                        <AddIcon />
                    </IconButton>
                    <UserNoteDialog
                        dialog_title={dialog_title}
                        is_dialog_open={is_dialog_open}
                        handleClose={this.handleNoteDialogClose}
                        handleSubmit={this.handleNoteDialogSubmit}
                        edit_tab_id={edit_tab_id}
                    />

                    <UserNoteAssetDialog
                        is_dialog_open={asset_dialog_open}
                        handleClose={this.handleNoteAssetDialogClose}
                        auth_id={this.props.auth.user.data.auth_id}
                        user_note_detail_id={this.props.current_user_note_detail_id}
                        activeNote={this.props.userNoteList.find(n => n.user_note_detail_id === this.props.current_user_note_detail_id)}
                        pullAssets={this.props.rePullNoteDetailAssets}
                        deleteAsset={this.props.deleteAsset}
                    />

                    <IconButton
                        onClick={this.handleClick}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={tabMenuAnchor}
                        open={tab_menu_open}
                        onClose={this.handleClose}
                    >
                        {userNoteList.map((user_note_detail) => (
                            <MenuItem
                                key={user_note_detail.user_note_detail_id}
                                value={user_note_detail.user_note_detail_id}
                                onClick={() => this.handleTabCheckboxSelect(user_note_detail.user_note_detail_id, user_note_detail.Active)}
                            >
                                <Checkbox checked={user_note_detail.Active ? true : false} />
                                <ListItemText primary={user_note_detail.ChapterName} />
                                <IconButton
                                    aria-label="Edit"
                                    onClick={(event) => this.handleEditTab(event, user_note_detail.user_note_detail_id)}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                    aria-label="Delete"
                                    onClick={(event) => this.deleteUserNoteDetail(event, user_note_detail.user_note_detail_id)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </MenuItem>
                        ))}
                    </Menu>

                    <IconButton onClick={() => toggleQuickPanel(false)}>
                        <ChevronRightIcon />
                    </IconButton>
                </div>

                <Divider />

                <div className={classes.drawerContent}>
                    <Tabs
                        value={current_tab}
                        onChange={this.changeTab}
                        scrollButtons="auto"
                        variant="scrollable"
                    >
                        {userNoteList.map((user_note_detail) => {
                            if (user_note_detail.Active) {
                                return (
                                    <Tab
                                        key={user_note_detail.user_note_detail_id}
                                        label={user_note_detail.ChapterName}
                                    />
                                )
                            }
                        })}
                    </Tabs>
                    <Divider />
                    <RichTextEditor
                        toolbarConfig={toolbarConfig}
                        value={current_note_text}
                        onChange={this.onEditorStateChange}
                        className={classes.editor}
                        disabled={active_list_length > 0 ? false : true}
                        editorStyle={{ 'minHeight': 700 }}
                    />
                </div>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUserNoteList: Actions.getUserNoteList,
        saveUserNoteDetail: Actions.saveUserNoteDetail,
        deleteUserNoteDetail: Actions.deleteUserNoteDetail,
        updateUserNoteDetail: Actions.updateUserNoteDetail,
        setCurrentNoteText: Actions.setCurrentNoteText,
        updateCurrentNoteText: Actions.updateCurrentNoteText,
        updateTabName: Actions.updateTabName,
        setActiveTab: Actions.setActiveTab,
        addTab: Actions.addTab,
        setCurrentTab: Actions.setCurrentTab,
        editTabName: Actions.editTabName,
        toggleQuickPanel: PanelActions.toggleQuickPanel,
        rePullNoteDetailAssets: Actions.rePullUserNoteDetailAssets,
        deleteUserNoteAsset: Actions.deleteUserNoteAsset,
        deleteAsset: AssetActions.deleteAsset
    }, dispatch);
}

function mapStateToProps({ note, auth }) {
    return {
        current_user_note_detail_id: note.user_note.current_user_note_detail_id,
        userNoteList: note.user_note.userNoteList,
        current_note_text: note.user_note.current_note_text,
        current_user_note_id: note.user_note.current_user_note_id,
        current_tab: note.user_note.current_tab,
        edit_tab_name: note.user_note.edit_tab_name,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(UserNote));



// WEBPACK FOOTER //
// src/main/components/note/UserNote.js